module.exports = __webpack_public_path__ + "img/logo_white.e1c8e783.png";